import { createFileRoute, redirect, notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { rendererClient } from "../lib/rendererClient";
import { getRequestHeader } from "@tanstack/react-start/server";
import type { LanguageKey } from "@op/puck-types";
import { contextSchema, type Context } from "../utils/context";

const redirectToLanguage = createServerFn({
  method: "GET",
})
  .inputValidator(contextSchema)
  .handler(async ({ data: { organizationSlug, projectSlug } }) => {
    const res = await rendererClient.projects[":organizationSlug"][
      ":projectSlug"
    ].languages.$get({
      param: {
        organizationSlug,
        projectSlug,
      },
    });
    if (!res.ok) {
      if (res.status === 404) throw notFound();
      throw new Error("Failed to fetch project languages");
    }
    const languages = await res.json();
    if (languages.length === 0) throw notFound();
    const acceptedLanguage = getRequestHeader("accept-language");
    if (!acceptedLanguage) {
      if (languages.map((l) => l.key).includes("en"))
        throw redirect({
          to: "/$languageKey",
          params: { languageKey: "en" },
          statusCode: 302,
        });
      else
        throw redirect({
          to: "/$languageKey",
          params: { languageKey: languages[0].key as LanguageKey },
          statusCode: 302,
        });
    } else {
      const languageFull = acceptedLanguage.split(",")[0];
      const languageKey = languageFull.split("-")[0];
      if (!languageKey) {
        if (languages.map((l) => l.key).includes("en"))
          throw redirect({
            to: "/$languageKey",
            params: { languageKey: "en" },
            statusCode: 302,
          });
        else
          throw redirect({
            to: "/$languageKey",
            params: { languageKey: languages[0].key as LanguageKey },
            statusCode: 302,
          });
      } else {
        if (languages.map((l) => l.key).includes(languageKey as LanguageKey))
          throw redirect({
            to: "/$languageKey",
            params: { languageKey: languageKey as LanguageKey },
            statusCode: 302,
          });
        else
          throw redirect({
            to: "/$languageKey",
            params: { languageKey: languages[0].key as LanguageKey },
            statusCode: 302,
          });
      }
    }
  });

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) =>
    await redirectToLanguage({ data: context as Context }),
});
